<template>
    <input ref="phoneInput"
           class="iti__tel-input"
           :class="{ 'error': hasError }">
</template>

<script>
import jQuery from 'jquery'
import IntlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

export default {
    name: "phone",

    props: {
        hasError: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object,
            default: () => null
        }
    },

    data () {
        return {
            input: null,
            phoneNumber: ''
        }
    },

    methods: {
        updateValue() {
            try {
                const rawNumber = this.input.getNumber();
                this.phoneNumber = rawNumber;

                if (this.input.isValidNumber()) {
                    const countryData = this.input.getSelectedCountryData();

                    return this.$emit('input', { phoneNumber: this.phoneNumber, countryData });
                }

                return this.$emit('input', { phoneNumber: this.phoneNumber });
            } catch (e) {
                console.log(e);
            }
        },

        setInitialValue() {
            if (this.value && this.value.phoneNumber && this.input) {
                try {
                    // Set the phone number
                    this.input.setNumber(this.value.phoneNumber);
                    
                    // Set the country if available
                    if (this.value.countryData && this.value.countryData.iso2) {
                        this.input.setCountry(this.value.countryData.iso2.toLowerCase());
                    }
                } catch (e) {
                    console.log('Error setting initial phone value:', e);
                }
            }
        },

        restrictToNumbers(event) {
            if (!/[0-9]/.test(event.key) && !event.ctrlKey && !event.metaKey && !event.altKey && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                event.preventDefault();
            }
        }
    },

    mounted () {
        const phoneInput = this.$refs.phoneInput

        this.input = IntlTelInput(phoneInput, {
            initialCountry: 'us',
            separateDialCode: true,
            preferredCountries: ['us', 'gb', 'ca', 'au', 'nz', 'ie'],
            loadUtils: () => import('intl-tel-input/utils'),
        })

        jQuery(phoneInput).on("countrychange", () => {
            this.updateValue()
        })

        phoneInput.addEventListener('input', this.updateValue)
        phoneInput.addEventListener('keydown', this.restrictToNumbers)

        // Set initial value if provided
        this.$nextTick(() => {
            this.setInitialValue()
        })
    },

    beforeDestroy() {
        try {
            if (this.input) {
                this.input.destroy()
            }
        } catch (e) {
            // Ignore destroy errors
        }
        
        // Force remove any remaining intl-tel-input elements
        const intlElements = document.querySelectorAll('.iti, .iti__flag, .iti__country-list, .iti__selected-flag')
        intlElements.forEach(el => el.remove())
        
        // Remove any intl-tel-input CSS classes from the input
        if (this.phoneInput) {
            this.phoneInput.className = this.phoneInput.className.replace(/iti[^ ]*/g, '').trim()
        }
    }
}

</script>
